<template>
  <footer id="layout-footer" class="legal">
    <div class="container-fluid">
      <div class="zone zone-after-footer">
        <article class="widget-after-footer widget-html-widget widget">
          <p>
            <span>© ORES</span>
            <span class="year">{{ year }}.</span>
            <span>{{ $t('Tous droits réservés') }}.&nbsp;</span>
            <a :href="$t('https://www.ores.be/conditions-generales')" target="_blank">{{ $t('Conditions générales') }}</a> -
            <a :href="$t('https://www.ores.be/politique-vie-privee')" target="_blank">{{ $t('Protection de la vie privée') }}</a> -
            <a :href="$t('https://www.ores.be/mentions-legales')" target="_blank">{{ $t('Mentions légales') }}</a> -
            <router-link to="/cookies-declaration" target="_blank">{{ $t('Déclaration relative aux Cookies') }}</router-link>
          </p>
        </article>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
